import { Component, OnInit } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { IAfterGuiAttachedParams, ICellRendererParams } from 'ag-grid-community';
import * as _ from 'lodash-es';

@Component({
  selector: 'pps-roster-code-checkbox',
  template: `
    <input type="checkbox" (click)="checkedHandler($event)" [checked]="checked" />
  `,
  styles: [
  ],
})
export class RosterCodeCheckboxComponent implements AgRendererComponent {
  params: any;
  checked: boolean;
  constructor() { }

  refresh(params: any): boolean {
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    
    if (this.params.column.colId === "can-be-used-in-timesheet"){
      this.checked = this.params.data.canBeUsedInTimesheet;
    }

    if (this.params.column.colId === "can-be-used-in-timesheet-breakdown-rule"){
      this.checked = this.params.data.canBeUsedInTimesheetBreakdownRule;
    }
  }

  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
    throw new Error("Method not implemented.");
  }

  checkedHandler(event) {
    let checked = event.target.checked;
    if (this.params.column.colId === "can-be-used-in-timesheet"){
      this.params.data.canBeUsedInTimesheet = checked;
    }

    if (this.params.column.colId === "can-be-used-in-timesheet-breakdown-rule"){
      this.params.data.canBeUsedInTimesheetBreakdownRule = checked;
    }

    this.params.context.componentParent.updateRosterCode(this.params.data);
  }  
}